import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";

// Assets
import "~/assets/sass/pages/common/settingPage/settingPage.scss";
import "~/assets/sass/pages/common/settingPage/Modal/settingModal.scss";
import EvalListModal from "../evaluateListModal/EvalListModal";
import DropdownList from "../components/DropdownList";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import Processing from "../processingModal/Processing";
import ProcessAlerts from "../processingModal/ProcessAlerts";
import lightInitImg from "~/assets/img/light-init-img.png";
import { useGlobalStore } from "~/store";
import useAlert from "~/common/hooks/useAlert";
import {Helmet} from "react-helmet";
import {getTitle} from "~/utils/getTitle";


const Setting = () => {

    const [
        {
            sidebar: { currentPath },
        },
    ] = useGlobalStore();

    const [showAuthAlert, AuthAlert] = useAlert();

    const { t } = useTranslation();
    //----온라인 심사 평가 항목 모달 --------------------------------------------------
    const [evaluateCategoryModal, setEvaluateCategoryModal] = useState(false);
    //----수정 클릭시 모달 ------------------------------------------------------------
    const [roundItemModal, setRoundItemModal] = useState(false);

    //----심사항목 삭제 Alert 모달 ----------------------------------------------------
    const [deleteAlertModal, setDeleteAlertModal] = useState(false);
    const [noCategoryAlert, setNoCategoryAlert] = useState(false);
    const [weightingAlert, setWeightingAlert] = useState(false);
    const [noEvaluationAlert, setNoEvaluationAlert] = useState(false);
    const [noTitleAlert, setNoTitleAlert] = useState(false);
    const [noCategoryName, setNoCategoryName] = useState(false);
    const [noItemName, setNoItemName] = useState(false);
    const [settingList, setSettingList] = useState([]);
    const [settingDetail, setSettingDetail] = useState({});
    const [evalCategories, setEvalCategories] = useState([]);
    const [step, setStap] = useState("");
    const settingListRequest = useRequest("get", "/vc/invest/setting/list");
    const settingDetailReqeust = useRequest("get", "/vc/invest/setting/detail");
    const settingCreateRequest = useRequest("post", "/vc/invest/setting/add");
    const settingModifyRequest = useRequest("post", "/vc/invest/setting/edit");
    const settingDeleteRequest = useRequest("delete", "/vc/invest/setting/delete");
    const [resetItemData, setResetData] = useState("");
    const [targetIdx, setTargetIdx] = useState("");

    //----신규 생성 ----------------------------------------------------
    const [createNew, setCreateNew] = useState("notCreate");

    const [formData, setFormData] = useState({ page: 1, size: 100 });
    const ref = useRef();

    useEffect(() => {
        settingListRequest.call(formData);
    }, [formData]);

    useEffect(() => {
        switch (settingListRequest.state) {
            case API_STATE.done:
                const resData = settingListRequest.response?.data.list;
                setSettingList(resData);
                break;
            case API_STATE.error:
                break;
            default:
                break;
        }
    }, [settingListRequest.state, settingListRequest.response, settingListRequest.error]);

    const deleteModalOpen = (idx) => {
        setTargetIdx(idx);
        setDeleteAlertModal(true);
    };

    const doDelete = (idx) => {
        settingDeleteRequest.call(idx, "path");
    };

    const modifyModalOpen = (idx) => {
        setCreateNew("notCreate");
        setTargetIdx(idx);
        setStap("process");
        settingDetailReqeust.call(idx, "path");
    };

    const handleNewCreation = (createFormData) => {
        settingCreateRequest.call(createFormData);
    };

    const handleModify = (modiFormData) => {
        settingModifyRequest.call(modiFormData);
    };

    const handleCreate = () => {
        setCreateNew("create");
        setRoundItemModal(true);
    };

    const handleSettingDetail = (idx) => {
        setCreateNew("notCreate");
        setStap("eval");
        settingDetailReqeust.call(idx, "path");
    };

    const headerButtons = [
        <button
            type="button"
            className="btn__solid"
            color="primary"
            onClick={() => {
                // if (currentPath.auth !== "edit") {
                //     showAuthAlert();
                //     return;
                // }
                handleCreate();
            }}
        >
            {t("common.commonWord.button.add")}
        </button>,
    ];

    useEffect(() => {
        switch (settingModifyRequest.state) {
            case API_STATE.done:
                setRoundItemModal(false);
                settingListRequest.call();
                break;
            case API_STATE.error:
                console.log(
                    `${t("common.commonWord.button.modify")} error !!! >>`,
                    settingModifyRequest.error
                );
                break;
            default:
                break;
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settingModifyRequest.state, settingModifyRequest.response, settingModifyRequest.error]);

    useEffect(() => {
        switch (settingDeleteRequest.state) {
            case API_STATE.done:
                setDeleteAlertModal(false);
                settingListRequest.call();
                break;
            case API_STATE.error:
                switch (settingDeleteRequest.error.statusCode) {
                    case 404:
                        alert(t("pages.investment.InvestSettingPage.index.alert01"));
                        setDeleteAlertModal(false);
                        break;
                    case 500:
                        alert(t("pages.investment.InvestSettingPage.index.alert02"));
                        setDeleteAlertModal(false);
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settingDeleteRequest.state, settingDeleteRequest.response, settingDeleteRequest.error]);

    useEffect(() => {
        switch (settingCreateRequest.state) {
            case API_STATE.done:
                setRoundItemModal(false);
                settingListRequest.call();
                break;
            case API_STATE.error:
                console.log("settingCreateRequest error !!! >> ", settingCreateRequest.error);
                break;
            default:
                break;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settingCreateRequest.state, settingCreateRequest.response, settingCreateRequest.error]);

    useEffect(() => {
        switch (settingDetailReqeust.state) {
            case API_STATE.done:
                setSettingDetail(settingDetailReqeust.response?.data);
                setEvalCategories(settingDetailReqeust.response?.data?.Category);
                step === "eval"
                    ? setEvaluateCategoryModal(true)
                    : step === "process"
                        ? setRoundItemModal(true)
                        : alert(t("pages.investment.InvestSettingPage.index.alert03"));
                break;
            case API_STATE.error:
                console.log("settingDetailReqeust error !!! >> ", settingDetailReqeust.error);
                break;
            default:
                break;
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settingDetailReqeust.state, settingDetailReqeust.response, settingDetailReqeust.error]);

    useEffect(() => {
        console.log("currentPath => ", currentPath);
    }, [currentPath])


    return(
        <>
            <Helmet>
                <title>{getTitle(`심사항목 등록/수정`)}</title>
            </Helmet>
            <NavbarAndSidebarLayout menu={["review", "setting"]} type={"main"}>
                <PageHeader buttonList={headerButtons} />
                <div className="c__cardRow">
                    {settingList.length > 0 ? (
                        settingList.map((d) => {
                            const itemLength = [];
                            d.Category?.map((cat) => cat.Item?.map((iem) => itemLength.push(iem)));
                            return (
                                <div className="c__card" key={d.idx}>
                                    <DropdownList
                                        target={d.idx}
                                        {...{
                                            modifyModalOpen,
                                            deleteModalOpen,
                                            showAuthAlert,
                                            currentPath,
                                        }}
                                    />
                                    <h3
                                        className="setting-title"
                                        onClick={() => handleSettingDetail(d.idx)}
                                    >
                                        {d.title}
                                    </h3>
                                    <div className="card-status">
									<span className="date">
										{moment(d.regDate).format("YYYY-MM-DD HH:mm:ss")}
									</span>
                                        <span className="item-number">{itemLength.length}</span>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        //---- Empty
                        <div className="page-init">
                            <p className="main">
                                {t("pages.investment.InvestSettingPage.index.empty.main")}
                            </p>
                            <p className="sub">
                                {t("pages.investment.InvestSettingPage.index.empty.sub")}
                            </p>
                            <img
                                src={lightInitImg}
                                alt={t("pages.investment.InvestSettingPage.index.empty.imageAlt")}
                            />
                        </div>
                    )}

                    <AuthAlert
                        message={
                            <>
                                권한이 없습니다. <br />
                                관리자에게 문의하세요.
                            </>
                        }
                        type="warning"
                        confirm="확인"
                    />
                </div>
                {/*카드 클릭시 온라인 심사 평가 항목 모달*/}
                <EvalListModal
                    {...{
                        settingDetail,
                        evalCategories,
                        evaluateCategoryModal,
                        setEvaluateCategoryModal,
                    }}
                />

                <Processing
                    {...{
                        settingDetail,
                        setSettingDetail,
                        createNew,
                        roundItemModal,
                        setRoundItemModal,
                        setNoCategoryAlert,
                        setWeightingAlert,
                        setNoEvaluationAlert,
                        setNoTitleAlert,
                        resetItemData,
                        setResetData,
                        setNoCategoryName,
                        setNoItemName,
                        handleModify,
                        handleNewCreation,
                        targetIdx,
                    }}
                />

                <ProcessAlerts
                    {...{
                        noCategoryAlert,
                        setNoCategoryAlert,
                        weightingAlert,
                        setWeightingAlert,
                        deleteAlertModal,
                        setDeleteAlertModal,
                        noEvaluationAlert,
                        setNoEvaluationAlert,
                        noTitleAlert,
                        setNoTitleAlert,
                        noCategoryName,
                        setNoCategoryName,
                        noItemName,
                        setNoItemName,
                        doDelete,
                        targetIdx,
                    }}
                />

                <div ref={ref} />
            </NavbarAndSidebarLayout>
        </>
    )
}

export default Setting
